import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { ReactNode } from 'react';

type LocationFormContentProps = {
    children: ReactNode;
    subtitle: string;
};

export const LocationFormContent = ({ children, subtitle }: LocationFormContentProps) => (
    <div className="flex flex-col gap-md">
        <BodyPrimary>{subtitle}</BodyPrimary>
        <div className="flex flex-col gap-md desktop:flex-row">{children}</div>
    </div>
);
